import { render, staticRenderFns } from "./designInfo.vue?vue&type=template&id=48bb9032&scoped=true&"
import script from "./designInfo.vue?vue&type=script&lang=js&"
export * from "./designInfo.vue?vue&type=script&lang=js&"
import style0 from "./designInfo.vue?vue&type=style&index=0&id=48bb9032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bb9032",
  null
  
)

export default component.exports